<template>
  <div class="container col-md-12">
    <h1>DC Balances Calculator</h1>
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>

    <div v-if="calcData">
      <hr />
      <h3>Result</h3>
      <md-content>
        <md-tabs>
          <md-tab
            :md-label="`${table.nominal_rate}%`"
            v-for="(table, index) in calcData.dc_balances_by_percent"
            v-bind:key="index"
          >
            <md-tabs md-border-bottom>
              <roe-dc-balance-table
                :label="'Pre Tax'"
                :data="table.pre_tax"
              ></roe-dc-balance-table>
              <roe-dc-balance-table
                :label="'Roth'"
                :data="table.roth"
              ></roe-dc-balance-table>
              <roe-dc-balance-table
                :label="'Post Tax'"
                :data="table.post_tax"
              ></roe-dc-balance-table>
              <roe-dc-balance-table
                :label="'Er Match'"
                :data="table.er_match"
              ></roe-dc-balance-table>
              <roe-dc-balance-table
                :label="'Er Other'"
                :data="table.er_other"
              ></roe-dc-balance-table>
              <roe-dc-balance-table
                :label="'NQDC'"
                :data="table.nqdc"
              ></roe-dc-balance-table>
            </md-tabs>
          </md-tab>
        </md-tabs>
      </md-content>
    </div>
  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
import RoeCalcInputFields from "@/components/calculators/InputFields";
import RoeDcBalanceTable from "@/components/calculators/DcBalanceTable";
import store from "@/store";
import { mapGetters } from "vuex";
import { CALC_DC_BALANCES, CALC_RESET_STATE } from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
export default {
  data() {
    return {
      calcAction: CALC_DC_BALANCES,
      inputCategories: [
        INPUT_TYPES.PARTICIPANT_BALANCE,
        INPUT_TYPES.PARTICIPANT,
        INPUT_TYPES.PLAN_BASIC_DATA,
        INPUT_TYPES.AUTO_ENROLLMENT,
        INPUT_TYPES.AUTO_INCREASE,
        INPUT_TYPES.EMPLOYEE_CONTRIBUTION,
        INPUT_TYPES.EMPLOYEE_MATCH,
        INPUT_TYPES.EMPLOYEE_OTHER,
        INPUT_TYPES.PRE_TAX_CONTRIBUTION,
        INPUT_TYPES.ROTH_CONTRIBUTION,
        INPUT_TYPES.POST_TAX_CONTRIBUTION,
        INPUT_TYPES.NQDC_CONTRIBUTION,
        INPUT_TYPES.COMPLIANCE_LIMIT
      ]
    };
  },
  components: { RoeCalcInputFields, RoeDcBalanceTable },
  computed: {
    ...mapGetters(["calcData"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
